import nlLanguage from '../translation/nl.json'

export enum Locale {
    nl = 'nl',
}

const locales: Record<Locale, any> = {
    [Locale.nl]: nlLanguage,
}

const trans = (path: string, params?: Record<string, string | number | undefined>): string => {
    const selectors = path.split('.')
    const paramKeys = Object.keys(params || {})

    const defaultLocale = Locale.nl

    let locale

    if (typeof window !== 'undefined') {
        locale = localStorage.getItem('locale') as Locale
    }

    let translation = locales[locale || defaultLocale]

    if (! translation) {
        translation = locales[defaultLocale]
    }

    for (let i = 0; i < selectors.length; i += 1) {
        const nextStep = translation[selectors[i]]

        if (! nextStep) {
            console.error(`No translation found for: ${path}`)
            return path
        }

        translation = nextStep
    }

    if (typeof translation !== 'string') {
        console.error(`No translation found for: ${path}`)
        return path
    }

    if (! params) {
        return translation
    }

    for (let i = 0; i < paramKeys.length; i += 1) {
        const regex = new RegExp(`:${paramKeys[i]}:`, 'g')

        translation = translation.replace(regex, params[paramKeys[i]])
    }

    return translation
}

export default trans
